export const generateDeclarationOfAttendanceText = (params: GenerateDeclarationTextParams) => {
  const { endHour, startHour, entranceDate, exitDate, patientName } = params;

  if (entranceDate === exitDate) {
    if (startHour && endHour && startHour !== endHour) {
      return `Declaro para os devidos fins que o(a) paciente ${patientName} esteve em atendimento no período das ${startHour} às ${endHour} do dia ${entranceDate}.`;
    }

    return `Declaro para os devidos fins que o(a) paciente ${patientName} esteve em atendimento no dia ${entranceDate}.`;
  }
  if (startHour && endHour) {
    return `Declaro para os devidos fins que o(a) paciente ${patientName} esteve em atendimento no período de ${startHour} do dia ${entranceDate} a ${endHour} do dia ${exitDate}.`;
  }
  return `Declaro para os devidos fins que o(a) paciente ${patientName} esteve em atendimento, no período de ${entranceDate} a ${exitDate}.`;
};

export const generateCompanionDeclarationOrMedicalCertificateText = (params: GenerateDeclarationTextParams) => {
  const { endHour, startHour, entranceDate, exitDate, patientName } = params;

  if (entranceDate === exitDate) {
    if (startHour && endHour && startHour !== endHour) {
      return `Declaro que o (a) Sr.(a) _________________________ esteve neste serviço de saúde no período das ${startHour} às ${endHour} do dia ${entranceDate}, acompanhando o paciente ${patientName}.`;
    }

    return `Declaro que o (a) Sr.(a) _________________________ esteve neste serviço de saúde no dia ${entranceDate}, acompanhando o paciente ${patientName}.`;
  }
  if (startHour && endHour) {
    return `Declaro que o (a) Sr.(a) _________________________ esteve neste serviço de saúde no período de ${startHour} do dia ${entranceDate} a ${endHour} do dia ${exitDate}, acompanhando o paciente ${patientName}.`;
  }

  return `Declaro que o (a) Sr.(a) _________________________ esteve neste serviço de saúde no período de ${entranceDate} a ${exitDate}, acompanhando o paciente ${patientName}.`;
};

export const generateCompanionMedicalCertificateText = (params: GenerateDeclarationTextParams) => {
  const { endHour, startHour, entranceDate, exitDate, patientName } = params;

  if (entranceDate === exitDate) {
    if (startHour && endHour && startHour !== endHour) {
      return `Declaro que o (a) Sr.(a) _________________________ esteve neste serviço de saúde no período das ${startHour} às ${endHour} do dia ${entranceDate}, acompanhando o paciente ${patientName}.`;
    }

    return `Declaro que o (a) Sr.(a) _________________________ esteve neste serviço de saúde no dia ${entranceDate}, acompanhando o paciente ${patientName}.`;
  }
  if (startHour && endHour) {
    return `Declaro que o (a) Sr.(a) _________________________ esteve neste serviço de saúde no período de ${startHour} do dia ${entranceDate} a ${endHour} do dia ${exitDate}, acompanhando o paciente ${patientName}.`;
  }

  return `Declaro que o (a) Sr.(a) _________________________ esteve neste serviço de saúde no período de ${entranceDate} a ${exitDate}, acompanhando o paciente ${patientName}.`;
};

interface GenerateDeclarationTextParams {
  startHour: string;
  entranceDate: string;
  endHour: string;
  exitDate: string;
  patientName: string;
}
